import {
  GET_RETAILER_PERFORMANCE_API,
  GET_RETAILER_PERFORMANCE_API_SUCCESS,
  GET_RETAILER_PERFORMANCE_API_FAILED,

  GET_MNP_ACTIVATION_API,
  GET_MNP_ACTIVATION_API_SUCCESS,
  GET_MNP_ACTIVATION_API_FAILED,

  GET_ATP_FSE_API,
  GET_ATP_FSE_API_SUCCESS,
  GET_ATP_FSE_API_FAILED,

  GET_ATP_OUTER_API,
  GET_ATP_OUTER_API_SUCCESS,
  GET_ATP_OUTER_API_FAILED,

  GET_ATP_INNER_API,
  GET_ATP_INNER_API_SUCCESS,
  GET_ATP_INNER_API_FAILED,
} from "../actions";

import { getTodaysDate } from "../../utils/common";
import config from "../../utils/config";

export const initialStateRetailerPerformance = {
  segregatedData: [],
  filterValue: {
    selectedRegion: "North",
    selectedState: "Delhi",
    selectedRole: "ZD - Shivalik Distribution Pvt Ltd - 0660002840",
    selectedRchain: "",
    selectedCategory: "All",
    selectedPartnerRoleType: "754",
    selectedPartnerRoleName: "ZD",
  },
  error: null,
  hierarchyData: null,
  mdnConnectivityData: null,
  headerSelectedDateFrom: getTodaysDate(config.startDate),
  headerSelectedDateTo: getTodaysDate(config.endDate),
  headerUnit: null,
  filteredArray: [],
  filterList: {
    loading: false,
    data: [],
    error: null,
  },
  getAllAPI: {
    loading: false,
    data: {},
    error: null,
  },
  retailerPerformanceObj: {
    loading: false,
    error: null,
    retailerPerformanceData: {},
  },
  mnpActivationObj: {
    loading: false,
    error: null,
    mnpActivationData: {},
  },
};

export function retailerPerformanceReducer(
  state = initialStateRetailerPerformance,
  action
) {
  switch (action.type) {
    case GET_RETAILER_PERFORMANCE_API:
      return {
        ...state,
        retailerPerformanceObj: {
          loading: true,
          error: null,
          retailerPerformanceData: {},
        },
      };
    case GET_RETAILER_PERFORMANCE_API_SUCCESS:
      let retailerTable = JSON.parse(
        JSON.stringify(state.retailerPerformanceObj.retailerPerformanceData)
      );
      retailerTable = [action.payload.content];
      return {
        ...state,
        retailerPerformanceObj: {
          loading: false,
          error: null,
          retailerPerformanceData: Object.assign(
            state.retailerPerformanceObj.retailerPerformanceData,
            retailerTable
          ),
        },
      };

    case GET_RETAILER_PERFORMANCE_API_FAILED:
      return {
        ...state,
        retailerPerformanceObj: {
          loading: false,
          error: action.error,
          retailerPerformanceData: {},
        },
      };

    case GET_MNP_ACTIVATION_API:
      return {
        ...state,
        mnpActivationObj: {
          loading: true,
          error: null,
          mnpActivationData: {},
        },
      };
    case GET_MNP_ACTIVATION_API_SUCCESS:
      let retailerMNPTable = JSON.parse(
        JSON.stringify(state.mnpActivationObj.mnpActivationData)
      );
      retailerMNPTable = [action.payload.content];
      return {
        ...state,
        mnpActivationObj: {
          loading: false,
          error: null,
          mnpActivationData: Object.assign(
            state.mnpActivationObj.mnpActivationData,
            retailerMNPTable
          ),
        },
      };
    case GET_MNP_ACTIVATION_API_FAILED:
      return {
        ...state,
        mnpActivationObj: {
          loading: false,
          error: action.error,
          mnpActivationData: {},
        },
      };

    case GET_ATP_FSE_API:
      return {
        ...state,
        atpFseObj: {
          loading: true,
          error: null,
          atpFseData: {},
        },
      };
    case GET_ATP_FSE_API_SUCCESS:
      let atpFseFilter = JSON.parse(
        JSON.stringify(state.atpFseObj.atpFseData)
      );
      atpFseFilter = [action.payload.content];
      return {
        ...state,
        atpFseObj: {
          loading: false,
          error: null,
          atpFseData: Object.assign(
            state.atpFseObj.atpFseData,
            atpFseFilter
          ),
        },
      };
    case GET_ATP_FSE_API_FAILED:
      return {
        ...state,
        atpFseData: {
          loading: false,
          error: action.error,
          atpFseData: {},
        },
      };

    case GET_ATP_OUTER_API:
      return {
        ...state,
        atpOuterObj: {
          loading: true,
          error: null,
          atpOuterData: {},
        },
      };
    case GET_ATP_OUTER_API_SUCCESS:
      let atpOuterTable = JSON.parse(
        JSON.stringify(state.atpOuterObj.atpOuterData)
      );
      atpOuterTable = [action.payload.content];
      return {
        ...state,
        atpOuterObj: {
          loading: false,
          error: null,
          atpOuterData: Object.assign(
            state.atpOuterObj.atpOuterData,
            atpOuterTable
          ),
        },
      };
    case GET_ATP_OUTER_API_FAILED:
      return {
        ...state,
        atpOuterObj: {
          loading: false,
          error: action.error,
          atpOuterData: {},
        },
      };

    case GET_ATP_INNER_API:
      return {
        ...state,
        atpInnerObj: {
          loading: true,
          error: null,
          atpInnerData: {},
        },
      };
    case GET_ATP_INNER_API_SUCCESS:
      let atpInnerTable = JSON.parse(
        JSON.stringify(state.atpInnerObj.atpInnerData)
      );
      atpInnerTable = [action.payload.content];
      return {
        ...state,
        atpInnerObj: {
          loading: false,
          error: null,
          atpInnerData: Object.assign(
            state.atpInnerObj.atpInnerData,
            atpInnerTable
          ),
        },
      };
    case GET_ATP_INNER_API_FAILED:
      return {
        ...state,
        atpInnerObj: {
          loading: false,
          error: action.error,
          atpInnerData: {},
        },
      };


    default:
      return state;
  }
}

export default retailerPerformanceReducer;
